import { LogLevel } from "@azure/msal-browser";
import { AppGlobals } from "./AppGlobals";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    //clientId: "6fc8967d-3ab5-4356-8a2d-9a2c5fdb9ad7",
    clientId: "",
    //authority: "https://login.microsoftonline.com/65f001db-6210-493d-acda-2251c3d224ca",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "", //"https://pfw0001.zedx.net",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */


export const loginRequest = {
  scopes: ["api://29098344-a2c0-4cfd-b443-87c27318f365/user_impersonation"], //ZedXAppsApi appreg
  //scopes: ["api://acaa0be8-c6dc-45da-9de1-031694c3d077/user_impersonation"], //adnan1442
  // authenticationParameters: {
  //   // Replace this with the URL of your custom icon
  //   logo: "https://placehold.co/64x64",
  // },
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
